import { render, staticRenderFns } from "./orderMealList.vue?vue&type=template&id=725dd0ff&scoped=true&"
import script from "./orderMealList.vue?vue&type=script&lang=js&"
export * from "./orderMealList.vue?vue&type=script&lang=js&"
import style0 from "./orderMealList.vue?vue&type=style&index=0&id=725dd0ff&prod&lang=less&scoped=true&"
import style1 from "./orderMealList.vue?vue&type=style&index=1&id=725dd0ff&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725dd0ff",
  null
  
)

export default component.exports